/**
 * Metric registry (`GET /v2/stats/metrics`) — SOURCE OF TRUTH for FE rendering:
 * `chartTypes` determines the allowed chart types, `aggregations` the allowed
 * aggregation functions, `servedBy` whether the metric is even plotted from the spine.
 * The registry only changes via migrations — cache it for a long time (see useMetricRegistry).
 */
import type {
  ApiMetricDefinition,
  FetchMetricsArgs,
} from './types/stats.types';

import { get } from './axios';

export const fetchMetricDefinitions = async (args: FetchMetricsArgs = {}) => {
  const response = await get<ApiMetricDefinition[]>('/v2/stats/metrics', {
    query: { category: args.category },
  });
  return response ?? [];
};
